import api from '@/common/libs/api'
import {responseResultValidate} from '@/common/libs/common.js';
export default {
  state: {
    cardBasicInfo: {}
  },
  mutations: {
    //获取年级列表
    getStudentCardBasicInfo(state, preload) {
      if (Object.keys(preload).length !=0) {
        state.cardBasicInfo = JSON.parse(JSON.stringify(preload));
      }
    }
  },
  actions: {
    getStudentCardBasicInfo({commit, dispatch}) {
      commit('isShowLoading', true);
      return api.apiMethod.getStudentCardBasicInfo.get().then(res => {
        commit('isShowLoading', false);
        if (responseResultValidate(res.data, {name: 'supplementaryCardInfo'})){ 
          if (res.data.errcode == 0) {
            commit('getStudentCardBasicInfo', res.data.data);
          } else {
            dispatch('toast', {title: res.data.msg, show: true});
          }
        }
      }); 
    }
  }
}


// WEBPACK FOOTER //
// ./src/stores/modules/studentCard/supplementaryCardInfo.js